import GetLicence from './GetLicence';

export default GetLicence;
